import { render, staticRenderFns } from "./oilStation.vue?vue&type=template&id=b6fa1810&scoped=true&"
import script from "./oilStation.vue?vue&type=script&lang=js&"
export * from "./oilStation.vue?vue&type=script&lang=js&"
import style0 from "./oilStation.vue?vue&type=style&index=0&id=b6fa1810&scoped=true&lang=css&"
import style1 from "./oilStation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa1810",
  null
  
)

export default component.exports